var HtmlComponent_default = {
  "htmlComponent": "_7S2Ve",
  "htmlComponent_placeholder": "F5Ttf"
};
export {
  HtmlComponent_default as default
};
//# sourceMappingURL=HtmlComponent-scss.js.map
